import { createAsyncThunk } from "@reduxjs/toolkit"

import { errorSave } from "../../../redux/errors.slice"
import { showResponseMessage } from "../../../utils/handlers/show-response-message.ts"
import * as services from "../api/services"
import type {
  NotificationSettings,
  NotificationSettingsItem
} from "../types/notification.types.ts"

// `silent` is for a read nobody asked for (the app shell learning the desktop
// preference), whose failure should not interrupt with an error toast.
export const fetchNotificationSettings = createAsyncThunk<
  NotificationSettings,
  { silent?: boolean } | void
>("notifications/settings", async (options, { dispatch, rejectWithValue }) => {
  const response = await services.getNotificationSettings()
  if (!response.ok) {
    if (!options?.silent) dispatch(errorSave(response?.data?.details))
    return rejectWithValue(response.data)
  }

  const raw = response.data
  return raw?.details?.data ?? raw
})

export const updateNotificationSettings = createAsyncThunk<
  NotificationSettingsItem[],
  NotificationSettingsItem[]
>(
  "notifications/updateSettings",
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.updateNotificationSettings(params)

    if (!response.ok) {
      dispatch(errorSave(response?.data?.details))
      return rejectWithValue(response.data)
    }

    showResponseMessage(response, "Notification settings updated successfully.")

    return params
  }
)
